import { store } from '@/core/store';

// eslint-disable-next-line import/prefer-default-export
export class ExtractRideCommand {
  #store = store;

  #payload;

  constructor(payload) {
    this.#payload = payload;
  }

  execute() {
    this.#store.dispatch('transferRide/extractRide', this.#payload);
  }
}
